export default "__VITE_ASSET__CFXu5M_2__"